import './App.css';
import MainSection from "./components/MainSection/MainSection";
import Question from "./components/Question/Question";

function App() {

  return (
    <div>
      <MainSection></MainSection>
      <Question></Question>
    </div>

  );
}

export default App;
